export const createActionConfig = ({ on = 'tap', type, config }) => ({
  on,
  type,
  ...(config ? { config } : {}),
});
